/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';
import { useTranslation } from 'react-i18next'
import { FilterButton, ModalHeader } from 'datastake-daf/dist/components';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Modal, Button, Select, Radio, Space, Form, Checkbox, Input, Divider, Popover } from 'antd';

import Loader from './loader';
import DropdownIndicator from './dropdown-indicator';
import { config } from '../../../../../../components/dashboards/config';
import { getPopupContainer } from '../../../../../../helpers/popUp';
import { propHasValue } from '../../../../../../components/DynamicFormNew/helper';

const FiltersWrapperStyle = styled.div`
  label {
    font-weight: 400;
    color: #262626;
  }

  .ant-checkbox-wrapper span {
    color: #595959;
  }

  label:not(:first-of-type) {
    margin-top: 4px;
  }
`;

const Style = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid ${config.BORDER_COLOR};
  border-radius: ${config.BORDER_RADIUS};
  overflow: hidden;
  width: 100%;
  position: relative;
  background: white;

  &.subject-toggled {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  &.overflow-visible {
    overflow: visible;
  }

  &::after {
    display: var(--backdrop);
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    background: #5C5C5C;
    opacity: 0.2;
    z-index: 2;
  }
  header {
    display: flex;
    color: black;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: ${config.TITLE.COLOR}; 
    font-size: ${config.TITLE.FONT_SIZE}; 
    font-weight: ${config.TITLE.FONT_WEIGHT};
		font-family: SF UI Display;
    padding: ${config.PADDING}px ${config.PADDING}px;
    width: 100%;
  }

  &.bordered-header {
    header {
      border-bottom: 1px solid ${config.BORDER_COLOR};
    }
  }

  .drawer {
    position: absolute;
    top: 0;
    right: 0;
    background: white;
    z-index: 3;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: var(--size);
    overflow-y: auto;
  }

  .custom-tooltip {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    h4 {
      font-size: 15px;
      margin-bottom: 0px;
    }

    .item {
      display: flex;
      flex-direction: row;

      .identifier {
        width: 10px;
        height: 10px;
        margin-right: 8px;
      }

      .value {
        margin-left: 15px;
        text-align: right;
        flex: 1;
        font-weight: 700;
        font-size: 14px;
        color: #595959;
      }

      .title {
        font-size: 13px;
      }
    }
  }

  .optional-header-content {
    position: absolute;
    right: 15px;
  }

  .ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
    color: #595959;
    font-weight: 400;
  }

  .drawer {
    overflow-y: auto;
  }

  &.project-frame {
    background: white;
    background: #FFFFFF;
    border-radius: 4px;
    height: 100%;
    border: 0px;

    header {
      margin-bottom: 0px;
      padding: ${config.PADDING}px ${config.PADDING}px 0 ${config.PADDING}px;
      border-bottom: 0px;
      font-size: ${config.TITLE.FONT_SIZE}px;
      color: black;
      font-weight: ${config.TITLE.FONT_WEIGHT};
    }

    &.map-header {
      header {
        padding-top: ${config.PADDING}px;
        padding-bottom: ${config.PADDING}px;
        border-bottom: 0px;
      }
    }
  }

  &.with-border {
    header {
      border-bottom: 1px solid ${config.BORDER_COLOR};
    }
  }

  &.h-full {
    height: 100%;
  }
`;

const WidgetFrame = ({
  title = 'Widget',
  filters = null,
  onFilterChange = () => { },
  onInit = () => { },
  children,
  drawer = null,
  overflowVisible = false,
  optionalHeaderContent = null,
  subjectToggled = false,
  onClearFilters = () => { },
  filtersTitle = null,
  className = '',
  tooltip,
  doPopOver = true,
  borderedHeader = true,
}) => {
  const { t } = useTranslation();
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [clearFiltersIsVisible, setClearFiltersIsVisible] = useState(false);
  const [form] = Form.useForm();
  const [ihneritValues, setIhneritValues] = useState({});
  const [ihneritedValues, setIhneritedValues] = useState([]);
  const [values, setValues] = useState({});

  useEffect(() => {
    if (filters) {
      if (filters.ihneritedValues) {
        setIhneritedValues(filters.ihneritedValues);
      }
    }
  }, [filters]);

  const hasDrawer = useMemo(() => drawer && drawer.props && drawer.props.children, [drawer]);

  const outActions = useMemo(() => ({
    close: () => setFiltersVisible(false),
    loading: (state) => setLoading(state),
    drawer: {
      open: () => hasDrawer ? setToggleDrawer(true) : setToggleDrawer(false),
      close: () => setToggleDrawer(false),
    },
    resetFilters: () => {
      form.resetFields();
      setValues({});
    },
    setClearFiltersVisibility: (state) => setClearFiltersIsVisible(state),
  }), [hasDrawer, form]);

  useEffect(() => {
    onInit(outActions);
  }, [])

  const clearUndefined = useCallback((obj) => Object.keys(obj).reduce((filters, key) => {
    if (propHasValue(obj[key])) {
      if (Array.isArray(obj[key])) {
        if (obj[key].length > 0) {
          filters[key] = obj[key];
        }
      } else {
        filters[key] = obj[key];
      }
    }
    return filters;
  }, {}), []);

  useEffect(() => {
    if (form) {
      form.resetFields(ihneritedValues);
    }
  }, [ihneritValues]);

  const selectFilter = ({ showIfHasValue, key, label, options, placeholder, divider, child, parent }) => {
    let optionsToMap;

    const removeValue = () => {
      const d = form.getFieldsValue();
      d[key] = undefined;
      form.setFieldsValue(d);
    };

    const v = form.getFieldsValue()[key];

    if (showIfHasValue) {
      const val = values[showIfHasValue];

      if (!val) {
        removeValue();
        return null;
      }
      optionsToMap = options.filter((o) => o.group === val);

      if (v && !optionsToMap.map((V) => V.value).includes(v) && options.length > 0) {
        removeValue();
      }
    } else {
      optionsToMap = options;
    }

    const mapOptions = (options) => options.map(option => (
      <Select.Option key={option.value} value={option.value}>
        {t(option.label)}
      </Select.Option>
    ));

    return (
      <React.Fragment key={key}>
        <label>{t(label)}</label>
        <Form.Item name={key}>
          <Select
            className="custom-select"
            key={key}
            {...getPopupContainer()}
            placeholder={t(placeholder) || t(label)}
            onChange={(e) => {
              if (parent) {
                setIhneritValues((prev) => ({ ...prev, [key]: parent[e] }));
              }
              setValues((prev) => ({ ...prev, [key]: e }));
            }}
            allowClear
          >
            {mapOptions(ihneritValues[child] || optionsToMap)}
          </Select>
        </Form.Item>
        {divider && <Divider style={{ marginBottom: 0 }} />}
      </React.Fragment>
    );
  };

  const comboBoxFilter = useCallback(({ key, label, options, placeholder, divider, child, parent }) => {
    const mapOptions = (options) => options.map(option => (
      <Select.Option key={option.value} value={option.value}>
        {t(option.label)}
      </Select.Option>
    ));

    return (
      <React.Fragment key={key}>
        <label>{t(label)}</label>
        <Form.Item name={key}>
          <Select
            className="custom-select"
            key={key}
            {...getPopupContainer()}
            placeholder={t(placeholder) || t(label)}
            onChange={(e) => {
              if (parent) {
                setIhneritValues((prev) => ({ ...prev, [key]: parent[e] }));
              }
            }}
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
          >
            {mapOptions(ihneritValues[child] || options)}
          </Select>
        </Form.Item>
        {divider && <Divider style={{ marginBottom: 0 }} />}
      </React.Fragment>
    );
  }, [ihneritValues, t]);

  const radioFilter = useCallback(({ key, label, options, defaultValue }) => (
    <React.Fragment key={key}>
      <label>{t(label)}</label>
      <Form.Item name={key}>
        <Radio.Group defaultValue={defaultValue}>
          <Space direction="vertical">
            {options.map(option => (
              <Radio key={option.value} value={option.value}>
                {t(option.label)}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>
    </React.Fragment>
  ), [t]);

  const checkboxFilter = useCallback(({ key, label, options }) => (
    <React.Fragment key={key}>
      <label>{t(label)}</label>
      <Form.Item name={key}>
        <Checkbox.Group>
          <Space direction="vertical">
            {options.map(option => (
              <Checkbox key={option.value} value={option.value}>
                {t(option.label)}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </Form.Item>
    </React.Fragment>
  ), [t]);

  const textFilter = useCallback(({ key, label }) => (
    <React.Fragment key={key}>
      <label>{t(label)}</label>
      <Form.Item name={key}>
        <Input type="text" placeholder={t(label)} />
      </Form.Item>
    </React.Fragment>
  ), [t]);

  const modalFilters = (settings) => {
    return Object.keys(settings).map(key => {
      switch (settings[key].type) {
        case 'select':
          return selectFilter({ showIfHasValue: settings[key].showIfHasValue, key, ...settings[key], child: settings[key].ihneritFrom, parent: settings[key].ihneritValues });
        case 'combobox':
          return comboBoxFilter({ key, ...settings[key], child: settings[key].ihneritFrom, parent: settings[key].ihneritValues });
        case 'radio':
          return radioFilter({ key, ...settings[key] });
        case 'checkbox':
          return checkboxFilter({ key, ...settings[key] });
        case 'text':
          return textFilter({ key, ...settings[key] });
        default:
          return 'Undefined filter type';
      }
    });
  };

  const resetFilters = useCallback(() => {
    form.resetFields();

    if (clearFiltersIsVisible) {
      onClearFilters();
    }
    onFilterChange({}, outActions);
    setValues({});

    setFiltersVisible(false);
  }, [onClearFilters, form, clearFiltersIsVisible]);

  const filtersRender = () => {
    if (filters && typeof filters === 'object') {
      switch (filters.type) {
        case 'modal':
          return (
            <Modal
              centered
              title={(
                <ModalHeader
                  title={`${filtersTitle || title}`}
                  actionButtons={clearFiltersIsVisible ? [
                    { type: 'primary', onClick: resetFilters, label: 'Dashboard::Clear filter(s)' }
                  ] : []}
                />
              )}
              open={filtersVisible}
              footer={null}
              width={320}
              onCancel={() => setFiltersVisible(false)}
            >
              <FiltersWrapperStyle className="filters-wrapper">
                <Form
                  name="filters"
                  form={form}
                  initialValues={filters.settings.default}
                  onFinish={(data) => {
                    setFiltersVisible(false);
                    const values = clearUndefined(data);
                    if (Object.values(values).length === 0) {
                      resetFilters();
                      return;
                    }
                    onFilterChange(values, outActions);
                  }}
                >
                  {modalFilters(filters.settings)}
                  <div className="filters-actions">
                    <Button onClick={() => setFiltersVisible(false)}>{t('Cancel')}</Button>
                    <Button type="primary" htmlType="submit">{t('Dashboard::Apply')}</Button>
                  </div>
                </Form>
              </FiltersWrapperStyle>
            </Modal >
          );
        case 'dropdown':
          return null;
        default:
          return modalFilters(filters.settings);
      }
    }
  };

  const filtersTrigger = useCallback(() => {
    if (filters && typeof filters === 'object') {
      switch (filters.type) {
        case 'modal':
        default:
          return (
            <div style={{ display: 'flex' }}>
              {(clearFiltersIsVisible) ? (
                <div className="clear-filters" onClick={resetFilters}>
                  <div>
                    <CloseOutlined
                      className="close-icon"
                    />
                  </div>
                  <div>
                    <span className="clear-filters-span">{t('Dashboard::Clear filter(s)')}</span>
                  </div>
                </div>
              ) : null}
              <FilterButton
                isActive={clearFiltersIsVisible}
                onClick={() => setFiltersVisible(true)}>
                {t('Dashboard::Filter')}
              </FilterButton>
            </div>
          )
        case 'dropdown':
          return (
            <div>
              <DropdownIndicator
                filters={filters}
                doPopOver={doPopOver}
                t={t}
                onFilterChange={onFilterChange}
              />
            </div>
          )
            ;
      }
    }
  }, [clearFiltersIsVisible, filters, onFilterChange, resetFilters, t]);

  return <Style
    className={formatClassname([
      overflowVisible && 'overflow-visible',
      subjectToggled && 'subject-toggled',
      className,
      borderedHeader && 'bordered-header',
    ])}
    style={{ '--backdrop': !toggleDrawer ? 'none' : 'flex' }}>
    <header>
      {title}
      {tooltip ? (
        <div className='ml-2 flex-1' style={{ marginTop: -8 }}>
          <Popover content={tooltip}>
            <InfoCircleOutlined
              style={{
                color: '#667085',
                fontSize: 15,
              }}
            />
          </Popover>
        </div>
      ) : null}
      {optionalHeaderContent && (
        <div className="optional-header-content">
          {optionalHeaderContent}
        </div>
      )}
      {filters && Object.keys(filters).length ? filtersTrigger() : null}

    </header>
    {children}
    {loading ? (
      <Loader />
    ) : null}
    {filtersRender()}
    {toggleDrawer ? (
      <div className="drawer">
        {drawer}
      </div>
    ) : null}
  </Style>;
}

export default WidgetFrame;
